import { Box, TableCell, Typography, styled } from '@mui/material';

export const Container = styled(Box)`
  width: 100%;
  max-width: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  font-family: sans-serif;
  font-size: 14px;
`;

export const Header = styled(Box)`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
`;

export const BackText = styled(Typography)`
  font-size: 14px;
  margin-left: 8px;
`;

export const TitleContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
`;

export const BlockTitle = styled(Typography)`
  font-size: 20px;
  font-weight: 500;
  width: 100%;
`;
export const SectionContainer = styled(Box)`
  padding: 8px 16px;
  width: 100%;
`;

export const SectionTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const StyledTableCellLabel = styled(TableCell)`
  font-size: 12px;
  font-weight: 400;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
  margin-left: auto;
`;

export const StyledTableCellValue = styled(TableCell)`
  font-size: 12px;
  font-weight: bold;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
  margin-left: auto;
`;
